import { render, staticRenderFns } from "./warning-member.vue?vue&type=template&id=f504270c&scoped=true"
import script from "./warning-member.vue?vue&type=script&lang=js"
export * from "./warning-member.vue?vue&type=script&lang=js"
import style0 from "./warning-member.vue?vue&type=style&index=0&id=f504270c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504270c",
  null
  
)

export default component.exports